import { render, staticRenderFns } from "./BlindPlateDetail.vue?vue&type=template&id=37e1f624&scoped=true"
import script from "./BlindPlateDetail.vue?vue&type=script&lang=js"
export * from "./BlindPlateDetail.vue?vue&type=script&lang=js"
import style0 from "./BlindPlateDetail.vue?vue&type=style&index=0&id=37e1f624&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e1f624",
  null
  
)

export default component.exports